import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "merge-field",
  "use": "merge-field-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"merge-field\"><path fill-rule=\"evenodd\" d=\"M6.5 13h2v-2h-2v2Zm4.5 0h2v-2h-2v2Zm4.5 0h2v-2h-2v2ZM7 3H4c-1.1 0-2 .9-2 2v4.005A2.005 2.005 0 0 1 0 11v2c1.099 0 1.997.897 2 1.995V19c0 1.1.9 2 2 2h3v-2H4v-5.002A2.005 2.005 0 0 0 2 12c1.1 0 1.999-.898 2-1.998V5h3V3Zm15 2c0-1.1-.9-2-2-2h-3v2h3v5c0 1.1.9 2 2 2-1.1 0-2 .9-2 2v5h-3v2h3c1.1 0 2-.9 2-2v-4c0-1.1.9-2 2-2v-2c-1.1 0-2-.9-2-2V5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol